function BrandGradientOverlay({ ref }: { ref?: React.Ref<HTMLSpanElement> }) {
	const handleMouseMove = (e: React.MouseEvent<HTMLSpanElement>) => {
		const rect = e.currentTarget.getBoundingClientRect()
		const x = ((e.clientX - rect.left) / rect.width) * 100
		const y = ((e.clientY - rect.top) / rect.height) * 100
		e.currentTarget.style.setProperty('--mouse-x', x.toString())
		e.currentTarget.style.setProperty('--mouse-y', y.toString())
	}

	return (
		/* biome-ignore lint/a11y/noNoninteractiveElementInteractions: the span is interactive used for gradient overlay */
		/* biome-ignore lint/a11y/noStaticElementInteractions: the span is interactive used for gradient overlay */
		<span
			className='absolute inset-0 z-1 bg-radial-(--dls19-brand-gradient-radial) bg-size-[200%_200%] opacity-0 transition-opacity duration-[1.25s] group-hover:opacity-100'
			onMouseMove={handleMouseMove}
			ref={ref}
			style={{
				backgroundPosition:
					'calc((100 - var(--mouse-x, 0)) * 1%) calc((100 - var(--mouse-y, 0)) * 1%)'
			}}
		/>
	)
}

export { BrandGradientOverlay }
